import React, { StatelessComponent } from 'react';
import cls from '../utils/classnames';
import { ROW } from '../utils/classes';
import './_styles.scss';

export interface IRowProps {
    /**
     * optional className to add to wrapper
     */
    className?: string;
}

export const Row: StatelessComponent<IRowProps> = props => {
    const { className, children } = props;
    const classNames = cls(ROW, className);
    return <div className={classNames}>{children}</div>;
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Row/index.tsx